import { render, staticRenderFns } from "./MakeCutIn.vue?vue&type=template&id=4c856786"
import script from "./MakeCutIn.vue?vue&type=script&lang=js"
export * from "./MakeCutIn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports